<template>
  <nav class="rk-secnav" aria-label="Page sections">
    <button
      v-for="s in sections"
      :key="s.id"
      class="rk-secnav__dot"
      :class="{ 'is-active': active === s.id }"
      @click="goTo(s.id)"
      :aria-label="s.label"
    >
      <span class="rk-secnav__tooltip">{{ s.label }}</span>
    </button>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const sections = [
  { id: 'home', label: 'Home' },
  { id: 'stats', label: 'By the numbers' },
  { id: 'how', label: 'How it works' },
  { id: 'features', label: 'Features' },
  { id: 'dashboard', label: 'See it in action' },
  { id: 'property-types', label: 'Property types' },
  { id: 'voices', label: 'Testimonials' },
  { id: 'security', label: 'Security' },
  { id: 'faq', label: 'FAQ' },
]

const active = ref('home')
let observer

const goTo = (id) => {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) active.value = entry.target.id
      })
    },
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  )
  sections.forEach((s) => {
    const el = document.getElementById(s.id)
    if (el) observer.observe(el)
  })
})

onUnmounted(() => observer?.disconnect())
</script>

<style scoped>
.rk-secnav {
  position: fixed;
  right: 1.75rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.rk-secnav__dot {
  position: relative;
  width: 10px; height: 10px;
  border-radius: 50%;
  background: rgba(16, 27, 45, 0.18);
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s var(--ease);
}
.rk-secnav__dot:hover { background: var(--brass); transform: scale(1.3); }
.rk-secnav__dot.is-active { background: var(--brass); box-shadow: 0 0 0 4px rgba(176,141,63,0.18); transform: scale(1.2); }

.rk-secnav__tooltip {
  position: absolute; right: 22px; top: 50%; transform: translateY(-50%);
  background: var(--ink); color: var(--paper);
  font-family: var(--font-mono); font-size: 0.72rem; white-space: nowrap;
  padding: 0.4rem 0.7rem; border-radius: var(--radius-sm);
  opacity: 0; pointer-events: none; transition: opacity 0.2s var(--ease);
}
.rk-secnav__dot:hover .rk-secnav__tooltip { opacity: 1; }

@media (max-width: 960px) {
  .rk-secnav { display: none; }
}
</style>